// extracted by mini-css-extract-plugin
export default {"cacheBar":"cacheBar_wTLfe","tabLabel":"tabLabel_DpDrq"};